__webpack_require__.p = "/stake/";